import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppShell from "@/components/AppShell";
import { Login, Register, ForgotPassword, ResetPassword } from "@/pages/Auth";
import Home from "@/pages/Home";
import Library from "@/pages/Library";
import Analyze from "@/pages/Analyze";
import Processing from "@/pages/Processing";
import Studio from "@/pages/Studio";
import Practice from "@/pages/Practice";
import Profile from "@/pages/Profile";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-center" theme="dark" richColors />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            <Route element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
              <Route path="/" element={<Home />} />
              <Route path="/library" element={<Library />} />
              <Route path="/analyze" element={<Analyze />} />
              <Route path="/processing/:jobId" element={<Processing />} />
              <Route path="/studio/:songId" element={<Studio />} />
              <Route path="/practice" element={<Practice />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/admin" element={<ProtectedRoute admin><Admin /></ProtectedRoute>} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
